import { publicConfig } from "./config";

const { PHP_SITE_DOMAIN, SITE_DOMAIN } = publicConfig;

const routes = {
	purchase: {
		base: "/purchase/",
		configSubscription: `${SITE_DOMAIN}/purchase/configure-subscription`,
		billing: "/purchase/billing",
		placeOrder: "/purchase/payment",
		invoice: "/purchase/invoice",
		confirmRenewal: "/purchase/confirm-renewal",
	},
	auth: {
		login: "/auth/login",
		signUp: "/auth/signup",
		logout: "/auth/sign-out",
		exchange: "/auth/exchange",
		forgotPassword: "/auth/forgot-password",
		forgotPasswordSuccess: "/auth/forgot-password/success",
		resetPassword: "/auth/reset-password",
		resetPasswordSuccess: "/auth/reset-password/success",
		resetPasswordFail: "/auth/reset-password/fail",
	},
	myAccount: `${SITE_DOMAIN}/account`,
	myAccountPreferences: "/account/preferences",
	account: {
		entitlements: {
			index: "/account/entitlements",
			activations: "/account/entitlements/activations",
		},
	},
	subscription: {
		dashboard: "/account/subscription",
		activations: "/account/subscription/activations",
		renew: "/account/subscription/renew",
		settings: "/account/subscription/settings",
		billing: {
			index: "/account/subscription/billing",
			changePaymentMethod: "/account/subscription/billing/changepayment",
			changePlan: "/account/subscription/billing/changeplan",
			activations: "/account/subscription/billing/activations",
		},
		entitlements: {
			index: "/account/subscription/entitlements",
			activations: "/account/subscription/entitlements/activations",
		},
		billingInfoUpdate: "/account/subscription/billinginfo-update",
		invoice: "/account/subscription/invoice",
		purchaseActivations: "/account/subscription/purchase-activations",
		cancelSurvey: "/account/subscription/cancel-survey",
		cancelConfirm: "/account/subscription/cancel-confirm",
		upgradeTrialPlan: "/account/subscription/upgrade-trial-plan",
		upgradeTrialSuccess: "/account/subscription/upgrade-trial-success",
		upgradeTrialPayment: "/account/subscription/upgrade-trial-payment",
	},
	invoice: {
		pay: "/invoice/pay",
		success: "/invoice/pay-success",
		invalid: "/invoice/invalid",
	},
	freeTrial: `${SITE_DOMAIN}/free-trial`,
	getStartedBiologics: "/get-started-biologics",
	confirmEmail: "/free-trial/confirm-email",
	completeProfile: "/free-trial/complete-profile",
	exchangeTrial: "/api/free-trial/exchange",
	quoteSuccess: "/quote/success",
	courseLicenses: "/free-course-license",
	igem: "/igem",
	features: {
		index: "/features/",
	},
	biopharma: "/biopharma/",

	errors: {
		403: "/403",
		404: "/404",
		default: "/error",
	},
	external: {
		index: "/",
		indexPhp: `//${PHP_SITE_DOMAIN}`,
		howToBuy: `//${PHP_SITE_DOMAIN}/pricing/`,
		support: "//support.geneious.com/",
		termsOfService: `//${PHP_SITE_DOMAIN}/legal/`,
		privacyPolicy: `//${PHP_SITE_DOMAIN}/privacy-policy/`,
		contactUs: `//${PHP_SITE_DOMAIN}/contact-us/`,
		prime: `//${PHP_SITE_DOMAIN}/prime/`,
		biopharma: `//${PHP_SITE_DOMAIN}/biopharma/`,
		customers: `//${PHP_SITE_DOMAIN}/resources/customers/`,
		solutions: `//${PHP_SITE_DOMAIN}/solutions/`,
		resources: `//${PHP_SITE_DOMAIN}/resources/`,
		tutorials: `//${PHP_SITE_DOMAIN}/tutorials/`,
		plugins: `//${PHP_SITE_DOMAIN}/plugins/`,
		whatsNew: `//${PHP_SITE_DOMAIN}/whats-new/`,
		crispr: `//${PHP_SITE_DOMAIN}/crispr/`,
		freeTrial: `${SITE_DOMAIN}/free-trial`,
		download: `//${PHP_SITE_DOMAIN}/download/`,
		quote: `//${PHP_SITE_DOMAIN}/quote/`,
		about: `//${PHP_SITE_DOMAIN}/about/`,
		leadership: `//${PHP_SITE_DOMAIN}/about/leadership/`,
		news: `//${PHP_SITE_DOMAIN}/about/news/`,
		careers: "https://www.dotmatics.com/about-careers",
		licenseAgreement: "//assets.geneious.com/legal/eula.html",
		manual: "https://manual.geneious.com/en/latest/",
		coronavirus: `//${PHP_SITE_DOMAIN}/resources/coronavirus-resources/`,
		help: "https://help.geneious.com/hc/en-us",
		freeTrialExternal: "https://manage-dev.geneious.com/free-trial",
		courseLicenses: `//${PHP_SITE_DOMAIN}/free-course-license`,
		igem: `//${PHP_SITE_DOMAIN}/igem`,
		dotmatics: "https://www.dotmatics.com/",
		portfolio: "https://www.dotmatics.com/portfolio",
		platform: "https://www.dotmatics.com/platform",
		careersExternal: "https://www.dotmatics.com/about-careers",
		citations: `//${PHP_SITE_DOMAIN}/resources/citations/`,
		features: `//${PHP_SITE_DOMAIN}/features/`,
		cloud: `//${PHP_SITE_DOMAIN}/features/cloud/`,
		security: `//${PHP_SITE_DOMAIN}/security/`,
		phylogeneticTreeBuilding: `//${PHP_SITE_DOMAIN}/features/phylogenetic-tree-building/`,
		academy: `//${PHP_SITE_DOMAIN}/academy/`,
		machineAccessTokenActivation: "https://help.geneious.com/hc/en-us/articles/23705323148308",
		nonFloatingLicenseInfoUrl:
			"https://help.geneious.com/hc/en-us/articles/23681334617748-Licensing-limits",
		doNotSell: "https://donotsell.dotmatics.com/hc/en-us/requests/new",
		requestDemo: `//${PHP_SITE_DOMAIN}/biopharma/request-demo/`,
		externalSignUp: "https://annotator.geneious.com/sign-up",
		gpLink: "https://policies.google.com/privacy",
		gtLink: "https://policies.google.com/terms",
		products: {
			prism: "//www.graphpad.com/",
			geneious: "//www.geneious.com/",
			snapgene: "//www.snapgene.com/",
			labArchives: "//www.labarchives.com/",
			proteinMetrics: "//proteinmetrics.com/",
			omiq: "//www.omiq.ai/",
			fcsExpress: "//denovosoftware.com/",
			nQuery: "//www.statsols.com/",
		},
		sequenceAnalysis: `//${PHP_SITE_DOMAIN}/features/#sequence-analysis`,
		molecularBiology: `//${PHP_SITE_DOMAIN}/features/#molecular-biology`,
		automation: `//${PHP_SITE_DOMAIN}/features/#automation`,
		biopharmaDiscovery: `//${PHP_SITE_DOMAIN}/biopharma/#antibody-discovery`,
		biopharmaClustering: `//${PHP_SITE_DOMAIN}/biopharma/features/clustering-filtering`,
		biopharmaSecurity: `//${PHP_SITE_DOMAIN}/biopharma/#collaboration-security`,
		academyGettingStarted: `//${PHP_SITE_DOMAIN}/academy/getting-started`,
		userManual: `//${PHP_SITE_DOMAIN}/manual`,
		academyAntibodyDiscovery: `//${PHP_SITE_DOMAIN}/academy/#antibody-discovery`,
		biopharmaDataSecurity: `//${PHP_SITE_DOMAIN}/biopharma/features/data-security`,
		biopharmaRequestDemo: `//${PHP_SITE_DOMAIN}/biopharma/request-demo`,

		externalGetStartedBiologics: `//${PHP_SITE_DOMAIN}/biopharma/get-started-free/`,
		knowledgeBase: "https://help.geneious.com/hc/en-us/categories/360003482792",
		biopharmaResourcesGS: "https://help.geneiousbiologics.com/hc/en-us/articles/360045069411",
		biopharmaUserGuide: "https://help.geneiousbiologics.com/hc/en-us/categories/360003073291",
		primeHelp: "https://help.geneious.com/",
		primeContactSupport: "https://help.geneious.com/hc/en-us/requests/new",
		biologicsHelp: "https://help.geneiousbiologics.com/",
		biologicsContactSupport: "https://help.geneiousbiologics.com/hc/en-us/requests/new",
		biologics: "https://biologics.geneious.com",
		biologicsStarter: "https://annotator.geneious.com",
	},
};
export default routes;
